import React, { useEffect, useState } from 'react';
import axios from 'axios';
import MenuBar from './MenuBar';
import ProductGrid from './ProductGrid';
import OrderPanel from './OrderPanel';
import { API_URL, ENDPOINTS } from '../../constants/api';
import { getToken } from '../../utils/TokenUtils';
import ProductSection from './ProductSection';

const POSPage = () => {
  const [products, setProducts] = useState([]);
  const [cart, setCart] = useState([]);
  const token = getToken();

  useEffect(() => {
  
      const url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/product-detail-report`;
      axios.post(url,  { category_id: '%' },{
        headers: { Authorization: token ? `Bearer ${token}` : '' },
      })
      .then((res)=> {
        console.log("response data:",res.data)
         setProducts(res.data.data || [])
        })
      .catch((err) => console.error('Error loading products:', err));
   

  }, []);

  const handleAddProduct = (product) => {
    setCart(prev => {
      const existing = prev.find(p => p.ID === product.ID);
      return existing
        ? prev.map(p => p.ID === product.ID ? { ...p, qty: p.qty + 1 } : p)
        : [...prev, { ...product, qty: 1 }];
    });
  };

  const handleUpdateQty = (id, qty) => {
    setCart(prev =>
      qty <= 0 ? prev.filter(item => item.ID !== id)
               : prev.map(item => (item.ID === id ? { ...item, qty } : item))
    );
  };

  return (
    <div className="d-flex gap-3 p-3">
      <div style={{ width: '70%' }}>
        {/* <MenuBar selected={selectedMenu} onSelect={setSelectedMenu} />
        <ProductGrid products={products} cart={cart} onAdd={handleAddProduct} /> */}
        <ProductSection products={products} cart={cart} onAdd={handleAddProduct} />
      </div>
      <div style={{ width: '30%' }}>
        <OrderPanel items={cart} setItems={setCart} onUpdateQty={handleUpdateQty} />
      </div>
    </div>
  );
};

export default POSPage;
